import { Injectable } from '@angular/core';

@Injectable()
export class CommonService {
    isIEorEdge = false;
}
